import { useBreakpointValue } from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useSubmit } from "react-router-dom";
import * as Yup from "yup";
import * as Constants from "../../constants/Constants";
import { twofix } from "../../helpers/utils/Utils";
import store from "../../store/store";

export const useGrubDialog = (props) => {
    // Hooks
    const submit = useSubmit();
    // States
    const [isOpens, setIsOpens] = useState(false);
    const [selectedModifiers, setSelectedModifiers] = useState([]);
    const [quantity, setQuantity] = useState(1);
    const [item, setItem] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            instruction: "",
        },
        validationSchema: Yup.object({
            instruction: Yup.string().max(
                255,
                Constants.VALID_SPECIAL_INSTRUCTION
            ),
        }),
        onSubmit: (values) => {
            submit(values, {
                method: Constants.POST,
                path: Constants.Products,
            });
        },
    });

    useEffect(() => {
        if (props.isOpen && store.getState().current_item.length > 0) {
            let selecte_mod = [];
            store.getState().current_item[0].modifier_set.map((item) => {
                if (item.selected_modifiers.length > 0) {
                    item.selected_modifiers.map((mod) => {
                        selecte_mod.push(mod.server_id);
                    });
                }
            });
            setSelectedModifiers(selecte_mod);
            let updatedItem = Object.assign({}, props.current_item[0]);
            updatedItem.sale_price = twofix(
                parseFloat(store.getState().current_item[0].sale_price) -
                    parseFloat(store.getState().current_item[0].total_modifiers_price)
            );
            updatedItem.online_ordering_price = twofix(
                parseFloat(store.getState().current_item[0].online_ordering_price) -
                    parseFloat(store.getState().current_item[0].total_modifiers_price)
            );
            formik.setFieldValue("instruction", updatedItem?.description || "");
            setQuantity(store.getState().current_item[0].quantity);
            setItem(updatedItem);
        }
    }, [props.isOpen]);

    const handleRadio = (modifier_set, modifier) => {
        let updateItem = { ...item }; // Use spread operator for shallow copy
        let toggleIndex = updateItem.modifier_set.findIndex(
            (o) => o.id === modifier_set.id
        );
        let c_modifier_set = updateItem.modifier_set[toggleIndex]; // get index of modifier set
        if (c_modifier_set.only_one) {
            // radio input if modifier set is "Select One"
            let rem_index = updateItem.modifier_set[
                toggleIndex
            ].selected_modifiers.findIndex((o) => o.id === modifier.id);
            if (rem_index < 0) {
                // This was not selected
                if (modifier.id !== Constants.NONE_MODIFIER.server_id) {
                    updateItem.modifier_set[toggleIndex].selected_modifiers = [
                        modifier,
                    ]; // Directly assign the selected modifier
                    const modifiers_id = modifier_set.modifiers.map(
                        (mod) => mod.id
                    );
                    const mySelectedArray = selectedModifiers.filter(
                        (el) => !modifiers_id.includes(el)
                    );
                    setSelectedModifiers([...mySelectedArray, modifier.id]);
                }
            } else {
                // This was already selected so we will unselect it
                updateItem.modifier_set[toggleIndex].selected_modifiers = [];
                const modifiers_id = modifier_set.modifiers.map(
                    (mod) => mod.server_id
                );
                const mySelectedArray = selectedModifiers.filter(
                    (el) => !modifiers_id.includes(el)
                );
                setSelectedModifiers(mySelectedArray);
            }
        } else {
            // checkbox input
            let rem_index = updateItem.modifier_set[
                toggleIndex
            ].selected_modifiers.findIndex((o) => o.id === modifier.id);
            if (rem_index < 0) {
                // This was not selected and multiple input we can check
                updateItem.modifier_set[toggleIndex].selected_modifiers.push(
                    modifier
                );
                setSelectedModifiers([...selectedModifiers, modifier.id]);
            } else {
                // This was already selected so we will unselect it
                const selected_modifiers = selectedModifiers.filter(
                    (x) => x !== modifier.id
                );
                setSelectedModifiers(selected_modifiers);
                updateItem.modifier_set[toggleIndex].selected_modifiers.splice(
                    rem_index,
                    1
                );
            }
        }
        let total_modifiers_price = updateItem.modifier_set.reduce(
            (total, item) => {
                if (item.selected_modifiers.length > 0) {
                    const single_price = item.selected_modifiers.reduce(
                        (prev, next) => prev + next.price,
                        0
                    );
                    item.total_modifiers_price = single_price;
                    return total + single_price;
                } else {
                    item.total_modifiers_price = 0;
                    return total;
                }
            },
            0
        );
        updateItem.total_modifiers_price = twofix(total_modifiers_price);
        setItem(updateItem);
    };

    const modalSizes = useBreakpointValue({
        base: "half",
        sm: "base",
        md: "sm",
        lg: "md",
        xl: "md",
    });

    const handleQuantityChange = (type) => {
        setQuantity((prev) =>
            type === "increment" ? prev + 1 : Math.max(1, prev - 1)
        );
    };

    const handleModifiersCloseModal = () => {
        props.removeCurrentItem();
        props.onClose();
        setSelectedModifiers([]);
        setQuantity(1);
        formik.resetForm();
    };

    const categoryName = props.current_item[0]?.categories[0]?.name || "";

    const handleAddToCart = async () => {
        if(formik.values.instruction.length > 255){
            return;
        }
        setIsLoading(true); // Disable button while processing
        let updateItem = item;
        if (
            undefined !== updateItem.total_modifiers_price &&
            null !== updateItem.total_modifiers_price &&
            "" !== updateItem.total_modifiers_price &&
            parseFloat(updateItem.total_modifiers_price) > 0
        ) {
            //think added modifier product
            if (
                null != updateItem.online_ordering_price &&
                undefined != updateItem.online_ordering_price &&
                "" != updateItem.online_ordering_price
            ) {
                updateItem.online_ordering_price = twofix(
                    parseFloat(updateItem.online_ordering_price) +
                        parseFloat(updateItem.total_modifiers_price)
                );
            } else {
                updateItem.sale_price = twofix(
                    parseFloat(updateItem.sale_price) +
                        parseFloat(updateItem.total_modifiers_price)
                );
            }
        } else {
            //think normal or default modifier product
            updateItem.total_modifiers_price = 0;
        }
            updateItem.description = formik.values.instruction.trim();

            updateItem.modifier_set.map((item) => {
                item.selected_modifiers.sort(function (a, b) {
                    // Return selected modifiers with apply sorting
                    return a.sort - b.sort;
                });
            });
            const current_order = await localStorage.getItem("current_order");
            props.insertItem(
                updateItem,
                quantity,
                current_order,
                props.order.order_for_here
            );
            props.orderCalculation(); // Reducer call to store order data
            let payload = {
                status: Constants.TOAST_TYPE_SUCESS,
                description: `${
                    updateItem?.name
                        ? `${updateItem.name.substring(0, 20)} ${
                              updateItem.name.length > 20 ? "..." : ""
                          }`
                        : ""
                } ${Constants.PRODUCT_ADDED_SUCCESS}`,
            };
            props.handleShowToast(payload);
            setTimeout(() => {
                props.removeCurrentItem();
                props.onClose();
                setIsLoading(false); // Re-enable button after modal closes
            }, 500);
        
    };

    const updateCartProduct = async () => {
        setIsLoading(true); // Disable button while processing
        let updateItem = Object.assign({}, item);
        if (
            updateItem.total_modifiers_price > 0 &&
            updateItem.total_modifiers_price != undefined
        ) {
            //think added modifier product
            updateItem.sale_price = twofix(
                parseFloat(updateItem.sale_price) +
                    parseFloat(updateItem.total_modifiers_price)
            );
        } else {
            //think normal or default modifier product
            updateItem.total_modifiers_price = 0;
            updateItem.sale_price = parseFloat(updateItem.sale_price);
        }
        updateItem.modifier_set.map((item) => {
            item.selected_modifiers.sort(function (a, b) {
                // Return selected modifiers with apply sorting
                return a.sort - b.sort;
            });
        });
        if (formik.values.instruction.length <= 255) {
            let storeItem = { ...updateItem };
            props.updateSelectedModifiers(storeItem); // CALL Reducer
            props.updateItemQty(
                storeItem,
                quantity,
                formik.values.instruction.trim()
            );
            props.orderCalculation(); // Reducer call to store order data
            props.removeCurrentItem();
            setIsLoading(false); // Re-enable button after processing
        } else {
            setIsLoading(false); // Re-enable if validation fails
            // addToast({
            //     alertStatus: Constants.TOAST_TYPE_WARNING,
            //     alertTitle: Constants.TOAST_HEADING_WARNING,
            //     alertDescription: Constants.VALID_SPECIAL_INSTRUCTION,
            // });
        }
    };

    const handleShowToast = (payload) => {
        props.handleShowToast(payload);
    };

    let sale_price = twofix(
        parseFloat(item?.online_ordering_price || item?.sale_price) +
            parseFloat(item?.total_modifiers_price)
    );
    const totalPrice = twofix(sale_price * quantity);
    return {
        handleAddToCart,
        updateCartProduct,
        handleModifiersCloseModal,
        handleRadio,
        handleQuantityChange,
        setSelectedModifiers,
        setQuantity,
        formik,
        totalPrice,
        quantity,
        modalSizes,
        categoryName,
        selectedModifiers,
        isLoading,
    };
};
